import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import FormField from "../VendorOnboarding/FormField";
import UploadImage from "assets/images/UploadImage.png";
import UploadCloud from "assets/icons/UploadCloud.svg";
import { SUB_ISSUE_MAP } from "../../constant/Home/PostJob";
import { humanizeEnum } from "../../utils/utils";

const Step5 = () => {
  const { values, setFieldValue } = useFormikContext();

  const issueLabel =
    {
      DOORS_WINDOWS: "Window & Door",
      LOCKSMITH: "Locksmith",
    }[values.issue_type] || humanizeEnum(values.issue_type) || "Issue";

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFieldValue("media_files", e.target.files[0]);
    }
  };

  // Auto-fill price estimate based on selected sub-issue type
  useEffect(() => {
    if (!values.issue_type || !values.sub_issue_type) {
      if (values.price_estimate) {
        setFieldValue("price_estimate", "");
      }
      return;
    }

    const subIssues = SUB_ISSUE_MAP[values.issue_type] || [];
    const activeSubIssue = subIssues.find(
      (option) => option.value === values.sub_issue_type
    );
    const nextEstimate = activeSubIssue?.priceRange || "";

    if (values.price_estimate !== nextEstimate) {
      setFieldValue("price_estimate", nextEstimate);
    }
  }, [values.issue_type, values.sub_issue_type, values.price_estimate, setFieldValue]);

  // Get sub-issue options based on selected issue type
  const getSubIssueOptions = () => {
    if (!values.issue_type) {
      return [];
    }
    return SUB_ISSUE_MAP[values.issue_type] || [];
  };

  const subIssueOptions = getSubIssueOptions();

  return (
    <div className=" flex justify-center items-center w-full">
      <div className="space-y-3 w-full">
        <div>
          <FormField
            label={`${issueLabel} Type:`}
            name="sub_issue_type"
            type="select"
            placeholder="Select a type"
            options={subIssueOptions}
          />
        </div>

        {/* Read-only Price Estimate below type dropdown */}
        <div>
          <FormField
            label="Price Estimate"
            name="price_estimate"
            type="text"
            placeholder="Auto-calculated from selection"
            readOnly
          />
        </div>

        {/* Description above upload field */}
        <div>
          <FormField
            label="Description"
            name="description"
            type="textarea"
            placeholder="Provide details to help us assess and resolve your issue"
            rows={3}
          />
        </div>

        <div>
          <div className="mb-1">
            <div className="border border-dashed border-gray-300 rounded-[5px]  p-[15px]">
              <div className="flex flex-col items-center justify-center">
                <img
                  src={UploadImage}
                  alt="Upload Image"
                  className="w-[36px] h-[36px] mb-2"
                />
                <div className="flex flex-col items-center justify-center gap-2">
                  <label className="cursor-pointer bg-[#F3F3F3] text-[#242424] hover:bg-gray-200 py-2 px-4 rounded-md gap-1 flex items-center justify-center ">
                    <img src={UploadCloud} alt="Upload Cloud" />
                    Upload File
                    <input
                      type="file"
                      accept="image/*,video/*"
                      onChange={handleFileChange}
                      className="hidden"
                    />
                  </label>
                  {values.media_files && (
                    <div className="mt-2 text-sm text-green-600">
                      File selected: {values.media_files.name}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step5;
